import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const alertVariants = cva(
  // eslint-disable-next-line @stylistic/max-len
  'relative w-full border p-[20px] text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-center [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current',
  {
    defaultVariants: {
      variant: 'default',
    },
    variants: {
      variant: {
        default: 'bg-card text-card-foreground',
        destructive:
          'text-destructive bg-[var(--error)] [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90',
      },
    },
  }
);

const Alert = ({
  className,
  variant,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof alertVariants>): React.JSX.Element => {
  return (
    <div className={cn(alertVariants({ variant }), className)}
      data-slot="alert"
      role="alert"
      {...props}
    />
  );
};

const AlertTitle = ({ className, ...props }: React.ComponentProps<'div'>): React.JSX.Element => {
  return (
    <div className={cn(
      'col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight',
      className
    )}
    data-slot="alert-title"
    {...props}
    />
  );
};

const AlertDescription = ({
  className,
  ...props
}: React.ComponentProps<'div'>): React.JSX.Element => {
  return (
    <div className={cn(
      'text-muted-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed',
      className
    )}
    data-slot="alert-description"
    {...props}
    />
  );
};

export { Alert, AlertDescription, AlertTitle };
